/* ==========================================================================
   GRAVITYPET™ - SCRIPTS COMPONENTES INTERACTIVOS
   ========================================================================== */

function mtInitAll() {
  sanitizePrivacyData();
  initReveal();
  initFAQ();
  initProductGallery();
  initVariantSelector();
  initStepsSlider();
  initProductBuyActions();
  initCrossellBundle();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mtInitAll);
} else {
  mtInitAll();
}

// 1. Reveal on scroll
function initReveal() {
  const reveals = document.querySelectorAll('.mt-reveal');
  if (!reveals.length) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(el => observer.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('mt-visible'));
  }
}

// 2. FAQ Accordion
function initFAQ() {
  const items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;

  items.forEach(item => {
    const header = item.querySelector('.mt-faq-header');
    if (!header || header._faqBound) return;
    header._faqBound = true;

    header.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isActive = item.classList.contains('active');
      items.forEach(i => i.classList.remove('active'));
      if (!isActive) {
        item.classList.add('active');
      }
    });
  });
}

// 3. Product Gallery (thumbnails to main image + navigation arrows + smooth slide transition + autoplay 2.5s)
function initProductGallery() {
  const gallery = document.querySelector('.mt-prod-gallery');
  if (!gallery) return;

  const track = gallery.querySelector('.mt-prod-track');
  const slides = Array.from(gallery.querySelectorAll('.mt-prod-slide'));
  const thumbs = Array.from(gallery.querySelectorAll('.mt-prod-thumb'));
  const prevBtn = gallery.querySelector('.mt-prod-prev');
  const nextBtn = gallery.querySelector('.mt-prod-next');
  const mainImgContainer = gallery.querySelector('.mt-prod-main-img');
  if (!slides.length) return;

  let activeIndex = thumbs.findIndex(t => t.classList.contains('active'));
  if (activeIndex === -1) {
    activeIndex = slides.findIndex(s => s.classList.contains('active'));
    if (activeIndex === -1) activeIndex = 0;
  }
  let autoplayTimer = null;
  const AUTOPLAY_DELAY = 2500; // 2.5 segundos en bucle
  let isGalleryInView = true;

  function showImageByIndex(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    activeIndex = index;

    // Desplazamiento horizontal fluido (slide) de la pista
    if (track) {
      track.style.transform = 'translateX(-' + (activeIndex * 100) + '%)';
    }

    // Actualizar clases activas en slides
    slides.forEach((s, i) => {
      if (i === activeIndex) {
        s.classList.add('active');
      } else {
        s.classList.remove('active');
      }
    });

    // Actualizar miniaturas
    thumbs.forEach((t, i) => {
      if (i === activeIndex) {
        t.classList.add('active');
        // Desplazamiento horizontal EXCLUSIVO dentro de la tira de miniaturas, SIN afectar el scroll de la ventana
        const thumbsContainer = gallery.querySelector('.mt-prod-thumbs');
        if (thumbsContainer) {
          const thumbLeft = t.offsetLeft;
          const thumbWidth = t.offsetWidth;
          const containerWidth = thumbsContainer.clientWidth;
          thumbsContainer.scrollTo({
            left: thumbLeft - (containerWidth / 2) + (thumbWidth / 2),
            behavior: 'smooth'
          });
        }
      } else {
        t.classList.remove('active');
      }
    });
  }

  // Inicializar en la posición actual
  showImageByIndex(activeIndex);

  function startAutoplay() {
    stopAutoplay();
    if (slides.length <= 1 || !isGalleryInView) return;
    autoplayTimer = setInterval(() => {
      showImageByIndex(activeIndex + 1);
    }, AUTOPLAY_DELAY);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  // Exponer para variant selector
  window.mtSelectGalleryIndex = function(index) {
    stopAutoplay();
    showImageByIndex(index);
    startAutoplay();
  };

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      stopAutoplay();
      showImageByIndex(i);
      startAutoplay();
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      stopAutoplay();
      showImageByIndex(activeIndex - 1);
      startAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      stopAutoplay();
      showImageByIndex(activeIndex + 1);
      startAutoplay();
    });
  }

  // Pausar con el ratón por encima y reanudar al salir
  gallery.addEventListener('mouseenter', () => {
    stopAutoplay();
  });

  gallery.addEventListener('mouseleave', () => {
    startAutoplay();
  });

  // Pausar en eventos táctiles
  gallery.addEventListener('touchstart', () => {
    stopAutoplay();
  }, { passive: true });

  gallery.addEventListener('touchend', () => {
    startAutoplay();
  }, { passive: true });

  // Soporte de gestos táctiles (swipe) suave en móvil
  if (mainImgContainer) {
    let touchStartX = 0;
    let touchStartY = 0;
    mainImgContainer.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      stopAutoplay();
    }, { passive: true });

    mainImgContainer.addEventListener('touchend', (e) => {
      const touchEndX = e.changedTouches[0].screenX;
      const touchEndY = e.changedTouches[0].screenY;
      const diffX = touchStartX - touchEndX;
      const diffY = touchStartY - touchEndY;
      // Solo disparar swipe horizontal si es mayor que el desplazamiento vertical y supera los 40px
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
        if (diffX > 0) {
          showImageByIndex(activeIndex + 1);
        } else {
          showImageByIndex(activeIndex - 1);
        }
      }
      startAutoplay();
    }, { passive: true });

    mainImgContainer.addEventListener('touchcancel', () => {
      startAutoplay();
    }, { passive: true });
  }

  // Pausar autoplay mientras el usuario hace scroll activo por la página
  let scrollTimer = null;
  window.addEventListener('scroll', () => {
    stopAutoplay();
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(() => {
      if (isGalleryInView) {
        startAutoplay();
      }
    }, 400);
  }, { passive: true });

  // Solo reproducir cuando la galería esté visible en la pantalla
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isGalleryInView = entry.isIntersecting;
        if (isGalleryInView) {
          startAutoplay();
        } else {
          stopAutoplay();
        }
      });
    }, { threshold: 0.1 });
    observer.observe(gallery);
  } else {
    startAutoplay();
  }
}

// 4. Variant Selector for mt-producto
function initVariantSelector() {
  const variantDataEl = document.getElementById('mt-variant-data');
  if (!variantDataEl) return;

  let variants = [];
  try {
    variants = JSON.parse(variantDataEl.textContent);
  } catch (e) {
    return;
  }

  const hiddenIdInput = document.querySelector('input[name="id"]');
  const priceCurrent = document.querySelector('.mt-price-current');
  const priceCompare = document.querySelector('.mt-price-compare');
  const addBtn = document.querySelector('.mt-add-to-cart-btn');
  const swatchChips = document.querySelectorAll('.mt-swatch-chip, .mt-color-btn, .mt-swatch-pill');
  const currentColorLabel = document.getElementById('mt-current-color-name');
  const thumbs = document.querySelectorAll('.mt-prod-thumb');
  const mainImg = document.querySelector('.mt-prod-main-img img');

  swatchChips.forEach(btn => {
    btn.addEventListener('click', () => {
      swatchChips.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const colorVal = btn.getAttribute('data-value');

      if (currentColorLabel) {
        currentColorLabel.textContent = colorVal;
      }

      // Buscar variante correspondiente
      const found = variants.find(v => {
        return v.title.toLowerCase().includes(colorVal.toLowerCase()) ||
               (v.options && v.options.some(opt => opt.toLowerCase() === colorVal.toLowerCase()));
      });

      if (found && hiddenIdInput) {
        hiddenIdInput.value = found.id;
        if (priceCurrent) {
          priceCurrent.textContent = (found.price / 100).toFixed(2).replace('.', ',') + ' €';
        }
        if (priceCompare) {
          let defaultComp = 5999;
          if (found.title && (found.title.toLowerCase().includes('round') || found.title.toLowerCase().includes('square') || found.title.toLowerCase().includes('redondo') || found.title.toLowerCase().includes('cuadrado'))) {
            defaultComp = 3499;
          }
          const compVal = (found.compare_at_price && found.compare_at_price > found.price) ? found.compare_at_price : defaultComp;
          priceCompare.textContent = (compVal / 100).toFixed(2).replace('.', ',') + ' €';
          const saveBadge = document.querySelector('.mt-price-save-badge');
          if (saveBadge) {
            const pct = Math.round(((compVal - found.price) / compVal) * 100);
            saveBadge.textContent = `${pct > 0 ? pct : 29}% OFF`;
          }
        }
        if (found.available) {
          if (addBtn) {
            addBtn.removeAttribute('disabled');
            addBtn.textContent = addBtn.getAttribute('data-text-add') || 'Añadir al Carrito';
          }
        } else {
          if (addBtn) {
            addBtn.setAttribute('disabled', 'disabled');
            addBtn.textContent = 'Agotado';
          }
        }

        // Mover carrusel a la foto de la variante seleccionada
        let matchedIndex = -1;

        // 1. Primero intentar por data-slide-index directo en el botón
        const btnSlideIndex = parseInt(btn.getAttribute('data-slide-index'), 10);
        if (!isNaN(btnSlideIndex) && btnSlideIndex >= 0) {
          matchedIndex = btnSlideIndex;
        }

        // 2. Si no, buscar por data-media-id en los slides o thumbs
        if (matchedIndex === -1) {
          const mediaId = btn.getAttribute('data-media-id') || (found && (found.featured_media?.id || found.featured_image?.id));
          if (mediaId) {
            const mediaIdStr = String(mediaId);
            thumbs.forEach((thumb, idx) => {
              if (matchedIndex === -1 && thumb.getAttribute('data-media-id') === mediaIdStr) {
                matchedIndex = idx;
              }
            });
            if (matchedIndex === -1) {
              const slides = document.querySelectorAll('.mt-prod-slide');
              slides.forEach((slide, idx) => {
                if (matchedIndex === -1 && slide.getAttribute('data-media-id') === mediaIdStr) {
                  matchedIndex = idx;
                }
              });
            }
          }
        }

        // 3. Si no, buscar por nombre de archivo de la imagen de la variante
        if (matchedIndex === -1 && found && (found.featured_image?.src || found.image)) {
          const rawSrc = String(found.featured_image?.src || found.image || '');
          const imgFileName = rawSrc.split('?')[0].split('/').pop().toLowerCase();
          if (imgFileName) {
            thumbs.forEach((thumb, idx) => {
              const full = (thumb.getAttribute('data-full') || '').toLowerCase();
              if (matchedIndex === -1 && full.includes(imgFileName)) {
                matchedIndex = idx;
              }
            });
          }
        }

        // 4. Si aún no, coincidencia por texto en alt/src
        if (matchedIndex === -1) {
          const targetColorSlug = colorVal.toLowerCase();
          thumbs.forEach((thumb, idx) => {
            const img = thumb.querySelector('img');
            const alt = (img && img.alt ? img.alt : '').toLowerCase();
            const src = (thumb.getAttribute('data-full') || '').toLowerCase();
            if (matchedIndex === -1 && (alt.includes(targetColorSlug) || src.includes(targetColorSlug))) {
              matchedIndex = idx;
            }
          });
        }

        if (matchedIndex !== -1 && window.mtSelectGalleryIndex) {
          window.mtSelectGalleryIndex(matchedIndex);
        }
      }
    });
  });
}

// 5. Steps Interactive Slider (MT - Cómo Funciona)
function initStepsSlider() {
  const sections = document.querySelectorAll('#mt-como-funciona, .mt-steps-wrap');
  if (!sections.length) return;

  sections.forEach(section => {
    const cards = section.querySelectorAll('.mt-step-card');
    const slides = section.querySelectorAll('.mt-step-slide');
    const track = section.querySelector('.mt-steps-track');
    const prevBtn = section.querySelector('.mt-step-prev');
    const nextBtn = section.querySelector('.mt-step-next');
    const sliderBox = section.querySelector('.mt-steps-slider');

    if (!cards.length || !slides.length) return;

    let currentIndex = 0;
    const total = cards.length;
    let autoplayTimer = null;
    const AUTOPLAY_DELAY = 2500; // 2.5 segundos en bucle
    let isSectionInView = true;

    function setActiveStep(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      currentIndex = index;

      // Desplazamiento horizontal fluido (slide) de la pista
      if (track) {
        track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      }

      // Actualizar tarjeta activa
      cards.forEach((card, i) => {
        if (i === currentIndex) {
          card.classList.add('active');
        } else {
          card.classList.remove('active');
        }
      });

      // Actualizar imagen activa
      slides.forEach((slide, i) => {
        if (i === currentIndex) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
    }

    // Inicializar posición
    setActiveStep(currentIndex);

    function startAutoplay() {
      stopAutoplay();
      if (!isSectionInView) return;
      autoplayTimer = setInterval(() => {
        setActiveStep(currentIndex + 1);
      }, AUTOPLAY_DELAY);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // Hover y Click en tarjetas de pasos
    cards.forEach((card, i) => {
      card.addEventListener('mouseenter', () => {
        stopAutoplay();
        setActiveStep(i);
      });
      card.addEventListener('mouseleave', () => {
        startAutoplay();
      });
      card.addEventListener('click', () => {
        stopAutoplay();
        setActiveStep(i);
        startAutoplay();
      });
    });

    // Flechas anterior y siguiente sobre la imagen
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        stopAutoplay();
        setActiveStep(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        stopAutoplay();
        setActiveStep(currentIndex + 1);
        startAutoplay();
      });
    }

    // Pausar solo cuando el ratón esté sobre la caja de fotos del slider
    if (sliderBox) {
      sliderBox.addEventListener('mouseenter', () => {
        stopAutoplay();
      });
      sliderBox.addEventListener('mouseleave', () => {
        startAutoplay();
      });

      // Soporte táctil (swipe) para móvil
      let touchStartX = 0;
      let touchStartY = 0;
      sliderBox.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        stopAutoplay();
      }, { passive: true });

      sliderBox.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const touchEndY = e.changedTouches[0].screenY;
        const diffX = touchStartX - touchEndX;
        const diffY = touchStartY - touchEndY;
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
          if (diffX > 0) {
            setActiveStep(currentIndex + 1);
          } else {
            setActiveStep(currentIndex - 1);
          }
        }
        startAutoplay();
      }, { passive: true });

      sliderBox.addEventListener('touchcancel', () => {
        startAutoplay();
      }, { passive: true });
    }

    // Pausar en eventos táctiles de la sección y reanudar
    section.addEventListener('touchstart', () => {
      stopAutoplay();
    }, { passive: true });

    section.addEventListener('touchend', () => {
      startAutoplay();
    }, { passive: true });

    section.addEventListener('touchcancel', () => {
      startAutoplay();
    }, { passive: true });

    // Pausar mientras se hace scroll activo y reanudar tras 300ms de calma
    let scrollTimer = null;
    window.addEventListener('scroll', () => {
      stopAutoplay();
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (isSectionInView) {
          startAutoplay();
        }
      }, 300);
    }, { passive: true });

    // Solo reproducir cuando la sección esté visible en pantalla
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          isSectionInView = entry.isIntersecting;
          if (isSectionInView) {
            startAutoplay();
          } else {
            stopAutoplay();
          }
        });
      }, { threshold: 0.05, rootMargin: '100px 0px 100px 0px' });
      observer.observe(section);
    } else {
      startAutoplay();
    }

    // Arrancar de inmediato
    startAutoplay();
  });
}

// 6. Scroll-to-Buy & Add-to-Cart Pulse (Ficha de Producto)
function initProductBuyActions() {
  const addToCartBtn = document.querySelector('.mt-add-to-cart-btn');
  if (!addToCartBtn) return; // Solo se ejecuta si existe el botón de añadir al carrito

  function pulseAddToCart() {
    addToCartBtn.classList.remove('mt-btn-pulse');
    void addToCartBtn.offsetWidth; // Forzar reflow para reiniciar la animación
    addToCartBtn.classList.add('mt-btn-pulse');
    setTimeout(() => {
      addToCartBtn.classList.remove('mt-btn-pulse');
    }, 1000);
  }

  // A) Pulso sutil de bienvenida al acceder a la página de producto
  if (!window.__mtProductPagePulsed) {
    window.__mtProductPagePulsed = true;
    setTimeout(() => {
      if (window.pageYOffset < 500) {
        pulseAddToCart();
      }
    }, 700);
  }

  // B) Clic en "Elegir mi GravityPet" (MT-Comparativa) o "Conseguir mi GravityPet" (MT-Llamada a la Acción)
  const buyTriggers = document.querySelectorAll('.mt-scroll-to-buy, .mt-comp-wrap .mt-btn, .mt-cta-card-wrap .mt-btn');
  buyTriggers.forEach(btn => {
    if (btn._buyScrollBound) return;
    btn._buyScrollBound = true;

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      // Scroll suave hasta arriba de todo
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      let hasPulsed = false;
      function triggerPulseAtTop() {
        if (hasPulsed) return;
        hasPulsed = true;
        setTimeout(pulseAddToCart, 120);
      }

      // Detectar llegada al principio de la página
      function checkScrollTop() {
        if (window.pageYOffset <= 15) {
          window.removeEventListener('scroll', checkScrollTop);
          triggerPulseAtTop();
        }
      }
      window.addEventListener('scroll', checkScrollTop, { passive: true });

      // Fallback de seguridad
      setTimeout(() => {
        window.removeEventListener('scroll', checkScrollTop);
        triggerPulseAtTop();
      }, 700);
    });
  });
}

// 7. Cross-Selling Bundle Handler (MT - Producto)
function initCrossellBundle() {
  const bundleCard = document.getElementById('mt-bundle-widget');
  const bundleCheckbox = document.getElementById('mt-bundle-checkbox');
  const productForm = document.getElementById('mt-product-form');
  const addBtn = document.querySelector('.mt-add-to-cart-btn');

  if (!bundleCard || !bundleCheckbox || !productForm || !addBtn) return;
  if (bundleCheckbox._bundleBound) return;
  bundleCheckbox._bundleBound = true;

  function updateButtonLabel() {
    const isChecked = bundleCheckbox.checked;
    if (isChecked) {
      bundleCard.classList.remove('unchecked');
      addBtn.textContent = 'Añadir Pack Bienestar (Comedero + Rompecabezas) • 54,98 €';
    } else {
      bundleCard.classList.add('unchecked');
      addBtn.textContent = addBtn.getAttribute('data-text-add') || 'Añadir al Carrito • 39,99 €';
    }
  }

  bundleCheckbox.addEventListener('change', updateButtonLabel);
  updateButtonLabel();

  // Si el usuario llega desde la ficha del rompecabezas (#mt-bundle-widget)
  if (window.location.hash === '#mt-bundle-widget') {
    bundleCheckbox.checked = true;
    updateButtonLabel();
    setTimeout(() => {
      bundleCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      bundleCard.style.transition = 'box-shadow 0.3s ease';
      bundleCard.style.boxShadow = '0 0 0 4px rgba(234, 88, 12, 0.35)';
      setTimeout(() => {
        bundleCard.style.boxShadow = '';
      }, 1500);
    }, 450);
  }

  // Interceptar envío para añadir ambos productos al carrito vía AJAX
  productForm.addEventListener('submit', function(e) {
    if (!bundleCheckbox.checked) {
      return;
    }

    e.preventDefault();
    const feederInput = productForm.querySelector('input[name="id"]');
    const feederVariantId = feederInput ? feederInput.value : null;
    const puzzleVariantId = bundleCheckbox.getAttribute('data-bundle-variant-id') || '55479328473430';

    if (!feederVariantId) return;

    addBtn.setAttribute('disabled', 'disabled');
    addBtn.textContent = 'Añadiendo Pack al carrito...';

    const itemsToAdd = [
      { id: parseInt(feederVariantId, 10), quantity: 1 },
      { id: parseInt(puzzleVariantId, 10), quantity: 1 }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: itemsToAdd })
    })
    .then(response => {
      if (response.ok) {
        window.location.href = '/cart';
      } else {
        productForm.submit();
      }
    })
    .catch(() => {
      productForm.submit();
    });
  });
}

// Soporte para editor de temas de Shopify
document.addEventListener('shopify:section:load', (event) => {
  sanitizePrivacyData();
  initReveal();
  initFAQ();
  initProductGallery();
  initVariantSelector();
  initStepsSlider();
  initProductBuyActions();
  initCrossellBundle();
});

// Sanitización de datos de contacto y privacidad en runtime
function sanitizePrivacyData() {
  const badEmails = [
    ['adritrg28', 'gmail.com'].join('@'),
    ['soportegravitypet', 'gmail.com'].join('@')
  ];
  const goodEmail = 'soporte@gravitypet.es';
  const badPhoneDigits = ['645', '53', '48', '91'].join('');

  document.querySelectorAll('a[href^="mailto:"]').forEach(a => {
    badEmails.forEach(bad => {
      if (a.href.indexOf(bad) !== -1) {
        a.href = 'mailto:' + goodEmail;
        if (a.textContent.indexOf(bad) !== -1) {
          a.textContent = goodEmail;
        }
      }
    });
  });

  document.querySelectorAll('a[href^="tel:"]').forEach(a => {
    if (a.href.indexOf(badPhoneDigits) !== -1) {
      a.remove();
    }
  });

  const containers = document.querySelectorAll('.shopify-policy__container, .gp-legal-card, .footer, main');
  containers.forEach(container => {
    var html = container.innerHTML;
    var modified = false;

    badEmails.forEach(bad => {
      if (html.indexOf(bad) !== -1) {
        html = html.split(bad).join(goodEmail);
        modified = true;
      }
    });

    if (html.indexOf('ll\u00e1menos al') !== -1) {
      html = html.replace(/ll\u00e1menos al\s*,?/gi, '');
      modified = true;
    }

    var oldAddrPattern = new RegExp(['Juan de Ciorraga', '1[ºAa]?,\\s*15008'].join(' '), 'gi');
    if (oldAddrPattern.test(html)) {
      html = html.replace(oldAddrPattern, 'Juan de Ciorraga, 15008');
      modified = true;
    }

    if (modified) {
      container.innerHTML = html;
    }
  });
}

// Delegación de apertura de panel de cookies desde cualquier botón o enlace
document.addEventListener('click', function(e) {
  var btn = e.target.closest('#openCookieSettingsBtn, .btn-cookie-preferences');
  if (btn) {
    e.preventDefault();
    if (typeof window.openCookieSettings === 'function') {
      window.openCookieSettings();
    } else {
      var modal = document.getElementById('gp-cookie-modal-backdrop');
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }
  }
});


